import styled from 'styled-components/macro';
import {
    Button,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    useToast
} from "@chakra-ui/react";
import {useState} from "react";
import {useFeedback} from "../../store/feedback";
import {useQuery} from "../../utils/router";
import {useRecover} from "../../api/reset";
import {useHistory} from "react-router-dom";
import {useLoggedIn} from "../../store";

const ChangePassword = styled(({onClose}) => {

    const {token} = useQuery();

    const [newPassword, setNewPassword] = useState();
    const [confirmNewPassword, setConfirmNewPassword] = useState();

    const {error, feedbackCh} = useFeedback();
    const recover = useRecover(feedbackCh);

    const [status, setStatus] = useState();

    const toast = useToast();
    const history = useHistory();
    const loggedIn = useLoggedIn();
    const handleNext = async () => {
        if (newPassword === confirmNewPassword) {
            try {
                await recover(token, newPassword);
                toast({
                    title: `Password has been reset.`,
                    status: 'success',
                    isClosable: true,
                });
                onClose();
                history.replace(loggedIn ? '/' : '/login');
            } catch (e) {
                setStatus(e.toString());
            }
        } else {
            setStatus('Passwords do not match.');
        }
    };

    return (
        <>
            <Modal
                isOpen
                onClose={onClose}
                size={'xl'}
                closeOnOverlayClick={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Set Password</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>

                        <Stack spacing={'5'}>

                            {!token &&
                                <>
                                    <p>You must specify a reset token.</p>
                                </>
                            }

                            {token &&
                                <>
                                    <FormControl>
                                        <FormLabel>New Password</FormLabel>
                                        <Input value={newPassword} type="password" onChange={(e) => setNewPassword(e.currentTarget.value)}/>
                                    </FormControl>
                                    <FormControl>
                                        <FormLabel>Confirm New Password</FormLabel>
                                        <Input value={confirmNewPassword} type="password" onChange={(e) => setConfirmNewPassword(e.currentTarget.value)}/>
                                    </FormControl>

                                </>
                            }

                            {status &&
                                <FormControl isInvalid>
                                    <FormErrorMessage>{status}</FormErrorMessage>
                                </FormControl>
                            }

                        </Stack>

                    </ModalBody>

                    <ModalFooter>
                        <Button variant="blue" onClick={handleNext}>
                            Done
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
})``;

export default ChangePassword;
